import { useEffect } from "react";
import { de } from "@ainkauf/core";

/** Rückgängig-Hinweis nach dem Abhaken. Fünf Sekunden, dann verschwindet er. */
export function UndoToast({ message, onUndo, onDismiss }: { message: string; onUndo: () => void; onDismiss: () => void }) {
  useEffect(() => {
    const timer = window.setTimeout(onDismiss, 5000);
    return () => {
      window.clearTimeout(timer);
    };
  }, [message, onDismiss]);

  return (
    <div
      role="status"
      data-testid="undo-toast"
      className="fixed inset-x-0 z-40 mx-auto flex w-fit max-w-[92vw] items-center gap-2 rounded-full bg-ink py-2 pl-5 pr-2 text-white shadow-[var(--shadow-float)]"
      // Über der unteren Leiste, nicht darauf.
      /*
        Auf der Navigationsleiste, nicht darüber: für die fünf Sekunden, die
        der Hinweis steht, braucht niemand die Leiste. So verdeckt er keinen
        Artikel und keinen Knopf, und der Mikro-Knopf bleibt frei.
      */
      style={{ bottom: "calc(var(--leiste) + env(safe-area-inset-bottom, 0px) + 12px)" }}
    >
      <span className="min-w-0 truncate text-sm">{message}</span>
      <button
        type="button"
        onClick={onUndo}
        data-testid="undo-button"
        className="min-h-[44px] shrink-0 rounded-full bg-white/20 px-4 font-semibold text-white"
      >
        {de.common.undo}
      </button>
    </div>
  );
}
